import script from "./BuilderView2.vue?vue&type=script&setup=true&lang=js"
export * from "./BuilderView2.vue?vue&type=script&setup=true&lang=js"

import "./BuilderView2.vue?vue&type=style&index=0&id=47b04dce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47b04dce"]])

export default __exports__